"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { keyframes } from "@emotion/react";
import { ExternalLinkIcon } from "@radix-ui/react-icons";
import { useCustomTheme } from "../../../../core/design-system/CustomThemeProvider.js";
import { iconSize, radius } from "../../../../core/design-system/index.js";
import { WalletImage } from "../../components/WalletImage.js";
import { Container, ModalHeader } from "../../components/basic.js";
import { ButtonLink } from "../../components/buttons.js";
import { StyledDiv } from "../../design-system/elements.js";
/**
 * @internal
 */
export const DeepLinkConnectUI = (props) => {
    const link = encodeURIComponent(window.location.toString());
    const deeplink = `${props.deepLinkPrefix}${link}?ref=${link}`;
    return (_jsxs(Container, { animate: "fadein", children: [_jsx(Container, { p: "lg", children: _jsx(ModalHeader, { onBack: props.onBack, title: props.walletInfo.name }) }), _jsx(Container, { flex: "row", center: "x", animate: "fadein", py: "3xl", children: _jsx(PulsatingContainer, { children: _jsx(WalletImage, { id: props.wallet.id, client: props.client, size: "80" }) }) }), _jsx(Container, { p: "lg", children: _jsxs(ButtonLink, { fullWidth: true, variant: "accent", href: deeplink, gap: "xs", children: ["Continue in ", props.walletInfo.name, _jsx(ExternalLinkIcon, { width: iconSize.sm, height: iconSize.sm })] }) })] }));
};
const pulseAnimation = keyframes `
0% {
  transform: scale(0.9);
}
100% {
  opacity: 0;
  transform: scale(1.4);
}
`;
const PulsatingContainer = /* @__PURE__ */ StyledDiv((_) => {
    const theme = useCustomTheme();
    return {
        position: "relative",
        "&::before": {
            content: '""',
            display: "block",
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            background: theme.colors.accentText,
            animation: `${pulseAnimation} 2s cubic-bezier(0.175, 0.885, 0.32, 1.1) infinite`,
            zIndex: -1,
            borderRadius: radius.xl,
        },
    };
});
//# sourceMappingURL=DeepLinkConnectUI.js.map